import { inject, Injectable, signal } from "@angular/core";
import { ApiProcess } from "@api/apiProcesses";
import { NominalLedgerApiService } from "@api/service/nominal-ledger.api.service";
import { ProcessRunnerApiService } from "@api/service/process-runner.api.service";
import { FeatureFlagsService } from "@core/feature-flags/page-feature-flags.service";
import { Module, Navigation } from "@core/navigation/navigation.model";
import { Permission } from "@core/permissions/permissions.model";
import { ProcessGroup } from "./processes.model";

@Injectable({
    providedIn: 'root'
})
export class ProcessesService {

    private processRunnerApiService = inject(ProcessRunnerApiService);
    private nominalLedgerApiService = inject(NominalLedgerApiService);
    private featureFlagsService = inject(FeatureFlagsService);

    PROCESSES_CONFIG = signal(<ProcessGroup[]>[
        {
            name: Module.AssetRegister,
            access: this.featureFlagsService.getNavigationFlag(Navigation.AssetRegisterProcessRun),
            processes: [
                {
                    name: 'Depreciate Assets',
                    code: ApiProcess.AssetRegisterDepreciationScheduleProcessJob,
                    process: () => this.processRunnerApiService.ProcessRunner.AssetRegister.Depreciation.Post(),
                    access: this.featureFlagsService.featureFlagAll(Permission.AssetRegisterProcessAssetRegisterDepreciationActionDefinition)
                }
            ],
        },
        {
            name: Module.NominalLedger,
            access: this.featureFlagsService.getNavigationFlag(Navigation.NominalLedgerProcessRun),
            processes: [
                {
                    name: 'End of Year',
                    code: ApiProcess.NominalLedgerEndOfYearJob,
                    process: () => this.nominalLedgerApiService.NominalLedger.Process.EndOfYear.Post(),
                    access: this.featureFlagsService.featureFlagAll(Permission.NominalLedgerProcessNominalLedgerEndOfYearActionDefinition)
                }
            ],
        },
    ])

    getModuleProcessRunConfig(module?:Module):ProcessGroup[];
    getModuleProcessRunConfig(...modules:Module[]):ProcessGroup[]{
        if(modules.length <= 0 || modules.includes(Module.ProcessRunner)){
            return this.PROCESSES_CONFIG();
        }
        else{
            return this.PROCESSES_CONFIG().filter((group) => modules.includes(group.name as Module));
        }
    }

}